import { ChartData } from '../../@types/data/types';
import {
  NonNullableLambdaAnalysisResults,
  NonNullableLiaoAnalysisResults,
  NonNullableLiaoSampleResults,
  NonNullableWaterOilInputSampleCurves
} from '../../@types/samples/types';

export const handleLiaoChartPoints = (
  analysisResults: NonNullableLiaoAnalysisResults,
  setNewChartData: React.Dispatch<React.SetStateAction<ChartData>>,
  inputSampleCurves: NonNullableWaterOilInputSampleCurves,
  liaoSampleResults: NonNullableLiaoSampleResults
) => {
  const { PcD, SwD, x, y } = analysisResults;
  const { true_pcd, true_swd } = liaoSampleResults;
  const PcD_x_SwD = PcD.map((pcd, index) => ({
    x: SwD[index],
    y: pcd
  }));

  const filteredPcDXSwD = PcD_x_SwD.filter(
    (value): value is { x: number; y: number } =>
      value.x !== null && value.y !== null
  );

  const pc_x_sw = inputSampleCurves.pc.map((field, index) => ({
    x: Number(inputSampleCurves.sw[index]),
    y: Number(field)
  }));

  const pceMatch = analysisResults.PceMatch ?? analysisResults.Pres;

  const PceMatch_x_CorrectedSw = pceMatch.map((field, index) => ({
    x: Number(analysisResults.CorrectedSw[index]),
    y: Number(field)
  }));

  const line = x.map((value, index) => ({
    x: Number(value),
    y: Number(y[index])
  }));

  const primaryCurve = [
    {
      x: true_swd,
      y: true_pcd
    },
    ...filteredPcDXSwD
  ].filter(
    (value): value is { x: number; y: number } =>
      value.x !== null &&
      value.y !== null &&
      Number.isFinite(value.x) &&
      Number.isFinite(value.y)
  )
    .sort((left, right) => left.x - right.x);

  setNewChartData(prevState => ({
    ...prevState,
    pcdxswd: filteredPcDXSwD,
    pcxsw: pc_x_sw,
    correctedPcxsw: PceMatch_x_CorrectedSw,
    line: line,
    new_pcxsw: [],
    new_pcdxswd: primaryCurve
  }));
};

export const handleLambdaChartPoints = (
  lambdaAnalysisResults: NonNullableLambdaAnalysisResults,
  setNewChartData: React.Dispatch<React.SetStateAction<ChartData>>,
  inputSampleCurves: NonNullableWaterOilInputSampleCurves
) => {
  const pc_x_sw = inputSampleCurves.pc.map((field, index) => ({
    x: Number(inputSampleCurves.sw[index]),
    y: Number(field)
  }));

  const correctedPcXCorrectedSw = lambdaAnalysisResults.CorrectedPc.map((field, index) => ({
    x: Number(lambdaAnalysisResults.CorrectedSw[index]),
    y: Number(field)
  }));

  setNewChartData(prevState => ({
    ...prevState,
    pcxsw: pc_x_sw,
    correctedPcxsw: correctedPcXCorrectedSw,
    new_pcxsw: []
  }));
};
